import { type CivilDate, dayOfWeek, daysInMonth } from '@klopotun/domain';

const DAYS_PER_WEEK = 7;

export const WEEKDAY_LABELS = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'];

/** A day of the month, or an empty cell before its first day and after its last. */
export type MonthGridCell = CivilDate | null;

export type MonthGridWeek = MonthGridCell[];

const blanks = (count: number): MonthGridCell[] => Array.from({ length: count }, () => null);

/** The month as rows of seven, Monday first, the way a wall calendar draws it. */
export const monthGridOf = (year: number, month: number): MonthGridWeek[] => {
  const leadingBlanks = dayOfWeek({ year, month, day: 1 }) - 1;
  const days: MonthGridCell[] = Array.from(
    { length: daysInMonth(year, month) },
    (_ignored, index) => ({
      year,
      month,
      day: index + 1,
    }),
  );
  const filled = [...blanks(leadingBlanks), ...days];
  const trailingBlanks = (DAYS_PER_WEEK - (filled.length % DAYS_PER_WEEK)) % DAYS_PER_WEEK;
  const cells = [...filled, ...blanks(trailingBlanks)];

  return Array.from({ length: cells.length / DAYS_PER_WEEK }, (_ignored, week) =>
    cells.slice(week * DAYS_PER_WEEK, (week + 1) * DAYS_PER_WEEK),
  );
};
